const request = {
    invalid_input: 'Girdi geçersiz. {{details}}',
    general: 'İstek hatası oluştu.',
};
export default request;
